import { Text } from '~/components/typography';

export const RadioBoxText = (props: any) => {
  const { children } = props;
  return (
    <Text textStyle="paragraph400" color="secondary">
      {children}
    </Text>
  );
};
